import './App.scss';
import Header from './compoments/header-footer/header';
import Footer from './compoments/header-footer/footer'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import Detailpage from './compoments/movieDetail/detailmovie';
import Home from './compoments/Home/home';
import Genres from './compoments/genre/genres';
import React from 'react';
import ScrollButton from './compoments/scrollbtn/ScrollButton';
import MovieHelmet from './compoments/SEO/MovieHelmet';
import Notfound from './compoments/notfound';
import BrowserMovies from './compoments/browser-movies';
import { ThemeProvider } from 'styled-components';
import { useDarkMode } from './theme/useDark';
import { GlobalStyles } from './theme/globalstyle';
import { lightTheme,darkTheme } from './theme/theme';
function App() {
  let NameApp = "DS Sombol Movies";
  const [theme, themeToggler] = useDarkMode();
  const themeMode = theme === 'light' ? lightTheme : darkTheme;
  return (
    <ThemeProvider theme={themeMode}>
        <MovieHelmet title={NameApp} />
        <BrowserRouter>
        <GlobalStyles/>
            <Header theme={theme} toggleTheme={themeToggler}/>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/detail/movies/:moviesId" component={Detailpage} />
                <Route exact path="/genre/:genres/" component={Genres}/>
                <Route exact path="/browsermovies" component={BrowserMovies}/>
                <Route exact path="/*" component={Notfound}/>
              </Switch>
              <ScrollButton />
            <Footer />
        </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
